import { render, staticRenderFns } from "./SpecialColumn.vue?vue&type=template&id=6c3b245e&scoped=true"
import script from "./SpecialColumn.vue?vue&type=script&lang=js"
export * from "./SpecialColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b245e",
  null
  
)

export default component.exports